var LeafletLayersObjectDiff = (function () {
    function LeafletLayersObjectDiff(remove, add) {
        this.remove = remove;
        this.add = add;
    }
    return LeafletLayersObjectDiff;
}());
export { LeafletLayersObjectDiff };
//# sourceMappingURL=leaflet-layers-object-diff.model.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/@asymmetrik/angular2-leaflet/dist/leaflet/layers/control/leaflet-layers-object-diff.model.js
// module id = ../../../../@asymmetrik/angular2-leaflet/dist/leaflet/layers/control/leaflet-layers-object-diff.model.js
// module chunks = 3